const compatModules = {};import * as Mod1 from "./discourse/adapters/user-note";
compatModules["discourse/adapters/user-note"] = Mod1;

export * as discourse$adapters$user__note$$__module from "./discourse/adapters/user-note";
export {
default as discourse$adapters$user__note$$default
} from "./discourse/adapters/user-note";
import * as Mod2 from "./discourse/components/modal/user-notes";
compatModules["discourse/components/modal/user-notes"] = Mod2;

export * as discourse$components$modal$user__notes$$__module from "./discourse/components/modal/user-notes";
export {
default as discourse$components$modal$user__notes$$default
} from "./discourse/components/modal/user-notes";
import * as Mod3 from "./discourse/components/post-metadata-user-notes";
compatModules["discourse/components/post-metadata-user-notes"] = Mod3;

export * as discourse$components$post__metadata__user__notes$$__module from "./discourse/components/post-metadata-user-notes";
export {
default as discourse$components$post__metadata__user__notes$$default
} from "./discourse/components/post-metadata-user-notes";
import * as Mod4 from "./discourse/components/show-user-notes";
compatModules["discourse/components/show-user-notes"] = Mod4;

export * as discourse$components$show__user__notes$$__module from "./discourse/components/show-user-notes";
export {
default as discourse$components$show__user__notes$$default
} from "./discourse/components/show-user-notes";
import * as Mod5 from "./discourse/components/user-note";
compatModules["discourse/components/user-note"] = Mod5;

export * as discourse$components$user__note$$__module from "./discourse/components/user-note";
export {
default as discourse$components$user__note$$default
} from "./discourse/components/user-note";
import * as Mod6 from "./discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags.gjs";
compatModules["discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags"] = Mod6;

export * as discourse$connectors$after__reviewable__post__user$show__user__notes__on__flags$$__module from "./discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags.gjs";
export {
default as discourse$connectors$after__reviewable__post__user$show__user__notes__on__flags$$default
} from "./discourse/connectors/after-reviewable-post-user/show-user-notes-on-flags.gjs";
import * as Mod7 from "./discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option.gjs";
compatModules["discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option"] = Mod7;

export * as discourse$connectors$reviewable__note__form__after__note$copy__reviewable__note__to__user__option$$__module from "./discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option.gjs";
export {
default as discourse$connectors$reviewable__note__form__after__note$copy__reviewable__note__to__user__option$$default
} from "./discourse/connectors/reviewable-note-form-after-note/copy-reviewable-note-to-user-option.gjs";
import * as Mod8 from "./discourse/connectors/user-card-post-names/show-user-notes-on-card.gjs";
compatModules["discourse/connectors/user-card-post-names/show-user-notes-on-card"] = Mod8;

export * as discourse$connectors$user__card__post__names$show__user__notes__on__card$$__module from "./discourse/connectors/user-card-post-names/show-user-notes-on-card.gjs";
export {
default as discourse$connectors$user__card__post__names$show__user__notes__on__card$$default
} from "./discourse/connectors/user-card-post-names/show-user-notes-on-card.gjs";
import * as Mod9 from "./discourse/connectors/user-profile-controls/show-notes-on-profile.gjs";
compatModules["discourse/connectors/user-profile-controls/show-notes-on-profile"] = Mod9;

export * as discourse$connectors$user__profile__controls$show__notes__on__profile$$__module from "./discourse/connectors/user-profile-controls/show-notes-on-profile.gjs";
export {
default as discourse$connectors$user__profile__controls$show__notes__on__profile$$default
} from "./discourse/connectors/user-profile-controls/show-notes-on-profile.gjs";
import * as Mod10 from "./discourse/initializers/enable-user-notes";
compatModules["discourse/initializers/enable-user-notes"] = Mod10;

export * as discourse$initializers$enable__user__notes$$__module from "./discourse/initializers/enable-user-notes";
export {
default as discourse$initializers$enable__user__notes$$default
} from "./discourse/initializers/enable-user-notes";
import * as Mod11 from "./discourse/lib/user-notes";
compatModules["discourse/lib/user-notes"] = Mod11;

export * as discourse$lib$user__notes$$__module from "./discourse/lib/user-notes";
export {
showUserNotes as discourse$lib$user__notes$$showUserNotes,
updatePostUserNotesCount as discourse$lib$user__notes$$updatePostUserNotesCount
} from "./discourse/lib/user-notes";
import * as Mod12 from "./discourse/pre-initializers/user-notes-transformers";
compatModules["discourse/pre-initializers/user-notes-transformers"] = Mod12;

export * as discourse$pre__initializers$user__notes__transformers$$__module from "./discourse/pre-initializers/user-notes-transformers";
export {
default as discourse$pre__initializers$user__notes__transformers$$default
} from "./discourse/pre-initializers/user-notes-transformers";
export default compatModules;
